import {
  GetAgencyDestination,
  EditAgencyDestination,
  InsertAgencyDestination,
  DeleteAgencyDestination,
} from "../type";import {  InsertData } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateAgencyDestinationAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/AgencyDestination`, data);
    dispatch({
      type: InsertAgencyDestination,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: InsertAgencyDestination,
      payload: "Error" + e,
    });
  }
};
export const UpdateAgencyDestinationAction = (data) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/AgencyDestination`, data);
    dispatch({
      type: EditAgencyDestination,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: EditAgencyDestination,
      payload: "Error" + e,
    });
  }
};
export const DeleteAgencyDestinationAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/AgencyDestination?id=${id}`);
    dispatch({
      type: DeleteAgencyDestination,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DeleteAgencyDestination,
      payload: "Error" + e,
    });
  }
};
export const GetAllAgencyDestinationAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/AgencyDestination`);
    dispatch({
      type: GetAgencyDestination,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GetAgencyDestination,
      payload: "Error" + e,
    });
  }
};